export default __webpack_public_path__ + "static/media/linkedin.cba3f7a6.png";